import axios from 'axios';
import cookies from "./cookies";

class HttpService {
    static PORTAL_SERVER = process.env.REACT_APP_PORTAL_SERVER;
    static API_SERVER = process.env.REACT_APP_API_SERVER;

    // نوع سرور پیش‌فرض
    static serverType = 'portal'; // 'portal' یا 'api'

    // گرفتن baseURL بر اساس نوع سرور
    static get baseURL() {
        return this.serverType === 'api' ? this.API_SERVER : this.PORTAL_SERVER;
    }

    // ایجاد instance داینامیک
    static get axiosInstance() {
        const instance = axios.create({
            baseURL: this.baseURL,
            headers: { 'Content-Type': 'application/json' },
            timeout: 10000,
        });

        instance.interceptors.request.use(
            (config) => {
                const token = (cookies()).get('token');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        return instance;
    }

    static get(url, params = {}) {
        return this.axiosInstance.get(url, { params });
    }

    static post(url, data = {}) {
        return this.axiosInstance.post(url, data);
    }

    static put(url, data = {}) {
        return this.axiosInstance.put(url, data);
    }

    static delete(url) {
        return this.axiosInstance.delete(url);
    }

    // تغییر سرور در هر زمان
    static setServer(type) {
        if (type === 'api' || type === 'portal') {
            this.serverType = type;
        } else {
            console.warn("Server type must be 'api' or 'portal'");
        }
    }
}

export default HttpService;
